import { ref, unref, watch, computed } from 'vue'
import moment from 'moment'

export function useVehicleStatus(vehicle) {
    let last_activity = null

    const vehicle_status = ref('')
    const vehicle_color = ref('')

    // REFACTOR-022 (Sprint 12): watch mirato sulle 3 subprop realmente usate
    // (lastpoint.date, activity_type, lastpoint.ignition) invece di deep:true
    // sull'intero truck. Il getter restituisce una signature-string (confronto ===)
    // → il callback rifà il dirty-check solo al cambio reale di queste 3, niente
    // deep-traverse ricorsivo dell'intero truck ×660 marker LTruckMarker.
    // Per un veicolo attivo `lastpoint.date` cambia ad ogni polling → il check di
    // freschezza (last_activity > 1h) resta vivo come prima. Vedi INVESTIGATION-001 F3.
    watch(
        () => {
            const v = unref(vehicle)
            return `${v?.lastpoint?.date}|${v?.activity_type}|${v?.lastpoint?.ignition}`
        },
        () => {
            const now = moment()
            const last_date = moment(unref(vehicle)?.lastpoint?.date).utc(true)

            if (last_date) last_activity = now.diff(last_date, 'hours')

            if (last_activity !== null && last_activity > 1) {
                vehicle_color.value = '--default-color'
                vehicle_status.value = 'default'
            } else {
                if (vehicle.value?.activity_type == 'moving') {
                    vehicle_color.value = '--moving-color'
                    vehicle_status.value = 'moving'
                } else if (vehicle.value?.activity_type == 'engine_on') {
                    vehicle_color.value = '--engine-on-color'
                    vehicle_status.value = 'engine-on'
                } else if (vehicle.value?.activity_type == 'ignition') {
                    vehicle_color.value = '--ignition-color'
                    vehicle_status.value = 'ignition'
                } else if (vehicle.value?.lastpoint?.ignition > 0) {
                    vehicle_color.value = '--ignition-color'
                    vehicle_status.value = 'ignition'
                } else {
                    vehicle_color.value = '--default-color'
                    vehicle_status.value = 'default'
                }
            }
        },
        { immediate: true }
    )

    // REFACTOR-002 (Sprint 8, cleanup #4): wrapper `var(--...)` pronto all'uso, così
    // i consumer non ripetono `var(${vehicle_color})` (era duplicato in 6 punti).
    const vehicle_color_var = computed(() => (vehicle_color.value ? `var(${vehicle_color.value})` : ''))

    return {
        vehicle_color,
        vehicle_color_var,
        vehicle_status
    }
}
